// UI-only constants. The product catalog itself lives in MongoDB and is
// fetched at runtime via `useProducts()` in /app/frontend/src/hooks/useProducts.js.
// Anything related to copy, hero imagery, or category labels belongs here.

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "hoodies", label: "Hoodies" },
  { id: "sweatshirts", label: "Sweatshirts" },
  { id: "tees", label: "Tees" },
  { id: "cropped-tees", label: "Cropped Tees" },
  { id: "accessories", label: "Accessories" },
];

export const KNOW_IT_OWLS_LOGO =
  "https://customer-assets.emergentagent.com/job_731778cc-5319-4c4f-85e7-2b7a45f8b041/artifacts/omgthzzr_knowitowls_st_smallweb_logo.png";

// Wall of Entertainment brand mark — used in Footer + trailer frame to
// highlight the production company behind the show.
export const WALL_OF_ENT_LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_wall-of-ent-show/artifacts/gfmuboag_WOE%20blue%20logo.png";

// Behind-the-scenes / Class in Action stills from the actual show set.
// First still is the hero "classroom" frame used in the Class in Action
// section — delivered through the WebP proxy (loaded in ClassInAction.jsx)
// so it's compressed + responsively sized automatically.
export const SHOW_STILLS = [
  "https://customer-assets.emergentagent.com/job_wall-of-ent-show/artifacts/rqit6hr9_16226cc4-7f18-40c0-a075-a9779fad773a.JPG",
  "/show/cb3-2.jpg",
  "/show/cb3-1.jpg",
];

// CB3 hero portrait — transparent PNG of CB3 in the Know It Owls yellow hoodie
export const HERO_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_wall-of-ent-show/artifacts/1yldm803_ST_CB%23_BANNER.png";

export const CAST_PORTRAIT = "/show/cb3-2.jpg";
